import Checkbox from "antd/lib/checkbox"
import { CheckboxChangeEvent } from "antd/lib/checkbox"
import Col from "antd/lib/col"
import Row from "antd/lib/row"
import { find, first } from "lodash"
import { useCallback, useEffect, useState } from "react"
import { connect, useDispatch, useSelector } from "react-redux"
import { useNavigate } from "react-router"

import { getNextDoctor } from "client/optic/selectors"
import { SOCKET_ENGINE_DIAGNOSTIC_START } from "client/socket/constants"
import { HARDWARE_LUNEAU_TYPE } from "client/socket/optic/contants"
import { Button } from "components/Button"
import { Buttons, Card } from "components/Card/Card"
import PreviousButton from "components/Previous/PreviousButton"
import Consent from "containers/Consent/Consent"
import { ContactlessPayment } from "containers/ContactlessPayment"
import { contactlessPaymentActions } from "containers/ContactlessPayment/services/actions"
import { ContactlessPaymentState } from "containers/ContactlessPayment/services/reducer"
import { PaymentCard } from "containers/Stripe"
import actionsSurvey from "containers/Survey/services/actions"
import { Answer } from "containers/Survey/types"
import { cdn } from "core/cdn"
import { CALL_PAGE, SURVEY_PAGE } from "core/constants"
import withSurveyController from "hocs/withSurveyController"
import { languages } from "lib/languages"
import { PATH } from "models/survey/_paths"
import { FOR_PATIENT } from "models/survey/constants"
import { DoctorType } from "types/entity"
import { Diagnostic } from "types/payload"
import { Dispatcher, Message } from "types/redux"
import { PaymentStore } from "types/store"
import { SocketStore } from "types/store"

import { logTerminalInformation } from "../../client/socket/actions"
import styles from "./Payment.module.scss"
import actions from "./services/actions"

import { GenericModal } from "components/Modal/Modal"
import { Alert } from "antd"
import { request } from "lib/request"
import config from "react-global-configuration"

const enum PaymentState {
  INITIALIZE = "INITIALIZE",
  EXEMPTED = "EXEMPTED",
  PAYMENT = "PAYMENT",
}

const Price = (props) => {
  if (!props.ophtalmologist) return <></>

  return (
    <div className={styles.Prices}>
      <div
        className={`${styles.PricesContainer} ${props.hardwareType !== HARDWARE_LUNEAU_TYPE && styles.ForNidekTimeline
          }`}
      >
        <div className={styles.PriceOphtalmologist}>
          Tarif : <b>{props.ophtalmologist.price}€</b>
        </div>
      </div>
    </div>
  )
}
const Payment = (props: PaymentStore & { diagnostic: Diagnostic }) => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [paymentState, setPaymentState] = useState(PaymentState.INITIALIZE)
  const [exempted, setExempted] = useState(false)
  const [currentPrice, setCurrentPrice] = useState(null)
  const nextDoctor: DoctorType | false = useSelector(getNextDoctor)
  const [setupIntentLoading, setSetupIntentLoading] = useState<boolean>(false);
  const hardwareType = useSelector(
    ({ socket }: { socket: SocketStore }) => socket.hardwareType
  )
  const [consentVisibility, setConsentVisibility] = useState(false)
  const answers = useSelector(({ survey }) => survey.answers)
  const [consentChoice, setConsentChoice] = useState<boolean>(false)
  const [paymentModalVisible, setPaymentModalVisible] = useState<boolean>(false);
  const { hasPaymentError: stripeError, hasSetupIntentError } = useSelector((state: any) => state.stripe);
  const [paymentMethod, setPaymentMethod] = useState<"card" | "contactlessPayment" | null>(null)
  const isReaderLinked = useSelector(
    ({ contactlessPayment }: { contactlessPayment: ContactlessPaymentState }) =>
      !!(
        contactlessPayment?.readerLinked?.readers_ids &&
        contactlessPayment.readerLinked.readers_ids.length > 0 &&
        !contactlessPayment.readerLinked.loading
      )
  )
  const { payment_intent_id, status: contactlessPaymentStatus } = useSelector(
    ({ contactlessPayment }: { contactlessPayment: ContactlessPaymentState }) => contactlessPayment
  )
  const [waitingTime, setWaitingTime] = useState<string>("")

  useEffect(() => {
    const nextDoctorId = nextDoctor === DoctorType.OPHTALMOLOGIST ? DoctorType.OPHTALMOLOGIST.toString() : DoctorType.ORTHOPTIST.toString();
    request<{ data: { displayed: string } }>(config.get("admin.eta") + `?category_id=${nextDoctorId}`, { method: 'GET' })
      .then((res) => {
        if (res?.data?.displayed) setWaitingTime(res.data.displayed)
      })
      .catch((err) => console.error(err))
  }, [])


  useEffect(() => {
    // no payment needed for orthoptist
    if (nextDoctor === DoctorType.OPHTALMOLOGIST && props.isExempted === false) {
      dispatch(actions.createPaymentIntent());
      dispatch(contactlessPaymentActions.readerCheckLinkedRequest());
    }
  }, [nextDoctor, props.isExempted, dispatch])

  useEffect(() => {
    if (hasSetupIntentError) {
      setSetupIntentLoading(false);
    }
  }, [hasSetupIntentError])

  useEffect(() => {
    if (stripeError && !props.isExempted) {
      setPaymentModalVisible(false);
      dispatch(actions.createPaymentIntent())
    }

  }, [stripeError, props.isExempted, dispatch])

  const [initialModalCheck, setInitialModalCheck] = useState<boolean>(false);
  const [dataConsentChoice, setDataConsentChoice] = useState<boolean>(false);
  //lancement du diagnostic des machines
  useEffect(() => {
    if (nextDoctor === DoctorType.ORTHOPTIST && props.success === true) {
      dispatch({ type: SOCKET_ENGINE_DIAGNOSTIC_START })
    }
  }, [nextDoctor, props.success, dispatch])

  useEffect(() => {
    if (nextDoctor === DoctorType.ORTHOPTIST) {
      setExempted(true)
      setPaymentState(PaymentState.EXEMPTED)
    } else if (!answers) {
      navigate(SURVEY_PAGE)
    } else {
      const exemptedFromStore = props.isExempted
      const exemptedFromAnswers = answers.find(
        (answer: Answer) =>
          answer.questionId === PATH.exemption &&
          Array.isArray(answer.value) &&
          first(answer.value) === true
      )
      const isExempted = exemptedFromStore || !!exemptedFromAnswers
      setExempted(isExempted)
      if (isExempted) {
        setPaymentState(PaymentState.EXEMPTED)
      }
    }
  }, [answers, props.isExempted, nextDoctor, navigate])

  useEffect(() => {
    // Retrieve terminal information and send them to API
    if (props.success) {
      dispatch(logTerminalInformation())
    }
  }, [props.success, dispatch])

  const getDoctorTimeline = (doctor: "orthoptist" | "ophtalmologist") => {
    return hardwareType === HARDWARE_LUNEAU_TYPE
      ? `/images/optic/timeline/frise_step_${doctor}.svg`
      : `/images/optic/timeline/nidek/frise_step_${doctor}.svg`
  }
  // Réception du prix
  useEffect(() => {
    const selectedPatientId = first(
      find(answers, (answer) => answer.questionId === PATH.patient)?.value
    )
    // DoctorType.ORTHOPTIST is always exempted no need to retrieve the price
    if (!props.price && nextDoctor === DoctorType.OPHTALMOLOGIST) {
      props.getPrice({
        relativeId:
          selectedPatientId === FOR_PATIENT
            ? undefined
            : (selectedPatientId as string),
        callTypeValue: nextDoctor as DoctorType
      })
    } else if (props.price) {
      const p =
        nextDoctor === DoctorType.ORTHOPTIST
          ? props.price.orthoptist
          : props.price.ophtalmologist
      setCurrentPrice(p)
    }
  }, [props.price, nextDoctor, answers, props.getPrice])

  useEffect(() => {
    if (props.success) {
      navigate(CALL_PAGE)
      props.reset()
    }
  }, [props.success, navigate, props.reset])

  const handleContactlessPaymentSuccess = useCallback(() => {
    if (payment_intent_id) {
      const contactlessPaymentAnswer: Answer[] = [
        {
          questionId: "payment_sheet_intent_id",
          value: [payment_intent_id],
        },
      ]
      props.tlcRequest([...answers, ...contactlessPaymentAnswer])
    }
    setPaymentModalVisible(false)
    setPaymentMethod(null)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [payment_intent_id, answers, props.tlcRequest])

  const handleContactlessPaymentCancel = useCallback(() => {
    // Fermer la modale immédiatement pour éviter l'affichage de l'état cancelled
    setPaymentModalVisible(false)
    setPaymentMethod(null)
    if (contactlessPaymentStatus === "creating" || contactlessPaymentStatus === "polling") {
      dispatch(contactlessPaymentActions.pollCancel())
      dispatch(contactlessPaymentActions.reset())
    }
  }, [contactlessPaymentStatus, dispatch])

  const handleSwitchToCard = useCallback(() => {
    // Si un paiement sans contact est en cours, on l'annule avant de basculer vers la carte
    if (contactlessPaymentStatus === "creating" || contactlessPaymentStatus === "polling") {
      dispatch(contactlessPaymentActions.pollCancel())
    }
    setPaymentMethod("card")
  }, [contactlessPaymentStatus, dispatch])

  switch (paymentState) {
    case PaymentState.PAYMENT:
    default:
      return (
        <Card
          titleSize="small"
          title={languages.youWillLaunchATLC}
          message={props.message}
          style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '25px', margin: 0 }}
        >
          <PreviousButton
            onClick={() => {
              setPaymentState(PaymentState.INITIALIZE)
            }}
            to={SURVEY_PAGE}
          />
          <div className={styles.PaymentInformation}>
            <Row align="middle" justify="center" gutter={[10, 10]}>
              <Col span={4}>
                <img src={cdn("/icons/picto_money.svg")} alt="" />
              </Col>
              <Col span={20}>
                {hasSetupIntentError ?
                  <Alert type="error" className={styles.AlertError} showIcon message={<span style={{ color: '#D1293A', fontSize: '28px', lineHeight: '40px' }}>{languages.createPaymentError}</span>} description={<><p style={{ color: '#D1293A', fontSize: '18px', lineHeight: '25px', fontWeight: 'unset' }}>{languages.retryLater}  <span>{languages.ifErrorStillOccur}</span></p><Button type="primary" wide="short" size="xsmall" onClick={() => { setSetupIntentLoading(true); dispatch({ type: "SETUP_PAYMENT_INTENT_REQUEST" }) }}>{languages.retry}</Button> </>} />
                  :
                  props.price ? (
                    nextDoctor === DoctorType.ORTHOPTIST ? (
                      <span className={styles.PaymentInformationText}>
                        {languages.priceAt}<b>{props.price?.orthoptist?.price}{" "}{languages.euroDevice}</b>{" "}
                        {languages.inTermsOfBilan}
                        <br />
                        <i>{props.price?.orthoptist?.content}</i>
                      </span>
                    ) : (
                      <span className={styles.PaymentInformationText}>
                        {languages.price}<b>{props.price?.ophtalmologist?.price}{" "} {languages.euroDevice}{" "}</b><i>{props.price?.ophtalmologist?.content}</i>
                        <br />
                      </span>
                    )
                  ) : (
                    <span className={styles.PaymentInformationText}>
                      {languages.loadingPrice}
                    </span>
                  )}
              </Col>
              {
                !hasSetupIntentError && (
                  <>
                    <Col span={4}>
                      <img src={cdn("/icons/picto_information.svg")} alt="" />
                    </Col>
                    <Col span={20}>
                      <span className={styles.PaymentInformationText}>
                        {languages.chargeAtTheEnd}
                      </span>
                    </Col>
                  </>
                )
              }
            </Row>
          </div>
          <Consent
            checked={initialModalCheck}
            onConsentChange={(isAllChecked) => setDataConsentChoice(isAllChecked)}
            visible={consentVisibility}
            onCancel={() => {
              setConsentVisibility(false)
            }}
            onAccept={() => {
              setConsentChoice(true)
              setDataConsentChoice(true);
              setConsentVisibility(false)
            }}
          ></Consent>
          <div style={{ width: '900px', paddingTop: '50px', padding: '20px 50px', margin: 'auto', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <Row>
              <Checkbox
                checked={consentChoice}
                onChange={(event: CheckboxChangeEvent) => {
                  setConsentChoice(event.target.checked)
                }}
              >
                {languages.IConfirmMyConsent}
              </Checkbox>
            </Row>
            <Row>
              <Checkbox
                checked={dataConsentChoice}
                onChange={(event: CheckboxChangeEvent) => {
                  setDataConsentChoice(event.target.checked);
                  setInitialModalCheck(event.target.checked);
                }}
              >
                {languages.IConfirmDataConsent}
                <span
                  className="more-information"
                  onClick={(ev) => {
                    ev.preventDefault()
                    setConsentVisibility(true)
                  }}
                >
                  {" "}
                  {languages.personalize}
                </span>
              </Checkbox>
            </Row>
            <Button
              loading={props.loading && !hasSetupIntentError}
              disabled={!consentChoice || !dataConsentChoice || props.loading || hasSetupIntentError}
              type="primary"
              style={{ marginTop: '50px' }}
              onClick={() => {
                if (props.isExempted) {
                  props.tlcRequest(answers)
                } else {
                  dispatch(contactlessPaymentActions.readerCheckLinkedRequest())
                  setPaymentMethod(null)
                  setPaymentModalVisible(true)
                }
              }}
            >
              {languages.payAndLaunchTLC}
            </Button>
            <span className={styles.EstimatedWaitingTime}>
              {languages.yourWaitingTimeEstimated} {waitingTime || "-"}
            </span>
          </div>
          {!props.isExempted && (
            <GenericModal
              visible={paymentModalVisible}
              footer={<></>}
              closable
              onClose={() => {
                // Si on ferme la modale pendant un paiement sans contact, on annule le paiement
                if (paymentMethod === "contactlessPayment") {
                  handleContactlessPaymentCancel()
                } else {
                  setPaymentModalVisible(false)
                  setPaymentMethod(null)
                }
              }}
            >
              {!isReaderLinked || paymentMethod === "card" ? (
                <PaymentCard
                  onPay={(pay: Answer[]) => {
                    const send = [...answers, ...pay]
                    props.tlcRequest(send)
                  }}
                />
              ) : !paymentMethod ? (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    padding: "60px",
                    gap: "66px",
                  }}
                >
                  <div
                    style={{
                      color: "#211452",
                      textAlign: "center",
                      fontFamily: "Now",
                      fontSize: "48px",
                      fontWeight: "700",
                    }}
                  >
                    {languages.choosePaymentMethod}
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "66px",
                      width: "100%",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <div
                      className={styles.paymentChoice}
                      onClick={() => setPaymentMethod("card")}
                    >
                      <img
                        src={cdn("/icons/payment/account_cards.svg")}
                        alt="Carte bancaire"
                        style={{ width: "120px", height: "120px" }}
                      />
                      <div
                        style={{
                          color: "#211452",
                          textAlign: "center",
                          fontFamily: "Now",
                          fontSize: "28px",
                          fontWeight: "400",
                        }}
                      >
                        {languages.payByCard}
                      </div>
                    </div>
                    <div onClick={() => setPaymentMethod("contactlessPayment")}>
                      <div
                        style={{
                          color: "#1D71B8",
                          textAlign: "center",
                          fontFamily: "Now",
                          fontSize: "28px",
                          fontWeight: "400",
                          textDecoration: "underline",
                        }}
                      >
                        {languages.payByContactlessPayment}
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <ContactlessPayment
                  onSuccess={handleContactlessPaymentSuccess}
                  onSwitchToCard={handleSwitchToCard}
                />
              )}
            </GenericModal>
          )}
        </Card>
      )
    case PaymentState.INITIALIZE:
    case PaymentState.EXEMPTED:
      const config =
        nextDoctor === DoctorType.ORTHOPTIST
          ? {
            title: languages.nextStepWithOrthoptist,
            imgUrl: getDoctorTimeline("orthoptist"),
          }
          : {
            title: languages.nextStepWithOphtalmologist,
            imgUrl: getDoctorTimeline("ophtalmologist"),
          }
      return (
        <Card
          title={config.title}
          // subtitle={languages.nextMeansYouAcceptCGU}
          // imgSize="medium"
          imgUrl={cdn(config.imgUrl)}
          imgPosition="bottom"
          message={props.message}
          className={styles.ExemptedImage}
        >
          {/* OPHTA-467 : à l'étape ophta, pas de retour vers le questionnaire */}
          {nextDoctor !== DoctorType.OPHTALMOLOGIST && (
            <PreviousButton
              onClick={() => {
                props.reset()
                dispatch(actionsSurvey.previous())
              }}
              to={SURVEY_PAGE}
            />
          )}
          {exempted ? (
            <div
              style={{
                maxWidth: "1375px",
                margin: "auto",
                marginTop: "-50px",
                marginBottom: "50px",
              }}
            >
              <Row>
                <Checkbox
                  checked={consentChoice}
                  onChange={(event: CheckboxChangeEvent) => {
                    setConsentChoice(event.target.checked)
                  }}
                >
                  {languages.IConfirmMyConsent}
                </Checkbox>
              </Row>
              <Row>
                <Checkbox
                  checked={dataConsentChoice}
                  onChange={(event: CheckboxChangeEvent) => {
                    setDataConsentChoice(event.target.checked);
                    setInitialModalCheck(event.target.checked);
                  }}
                  style={{ zIndex: 1 }}
                >
                  {languages.IConfirmDataConsent}
                  <span

                    className="more-information"
                    onClick={(ev) => {
                      ev.preventDefault()
                      setConsentVisibility(true)
                    }}
                  >
                    {" "}
                    {languages.personalize}
                  </span>
                </Checkbox>
              </Row>
            </div>
          ) : null}
          {exempted ? null : (
            <Price
              hardwareType={hardwareType}
              nextDoctor={nextDoctor}
              ophtalmologist={props.price?.ophtalmologist}
              orthoptist={props.price?.orthoptist}
            />
          )}
          {nextDoctor === DoctorType.OPHTALMOLOGIST ? (
            <div className={styles.Infos}>
              <img src={cdn("/icons/information.svg")} width="30px" alt="information" />
              <span>
                {props.isExempted ? languages.tlcExemptedRepeat
                  : languages.additionalFeeCanBeCharged}
              </span>
            </div>
          ) : null}
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
            <Buttons style={{ paddingTop: 0 }}>
              <Button
                type="primary"
                disabled={(exempted && !consentChoice) || (exempted && !dataConsentChoice) || props.loading}
                loading={props.loading}
                onClick={() => {
                  exempted && props.tlcRequest(answers)
                  !exempted && setPaymentState(PaymentState.PAYMENT)
                }}
              >
                {exempted ? languages.createCall : languages.next}
              </Button>
            </Buttons>
            <span className={styles.EstimatedWaitingTime}>
              {languages.yourWaitingTimeEstimated} {waitingTime || "-"}
            </span>
          </div>
          <Consent
            checked={initialModalCheck}
            onConsentChange={(isAllChecked) => setDataConsentChoice(isAllChecked)}
            visible={consentVisibility}
            onCancel={() => {
              setConsentVisibility(false)
            }}
            onAccept={() => {
              setConsentChoice(true)
              setDataConsentChoice(true);
              setConsentVisibility(false)
            }}
          ></Consent>
        </Card>
      )
  }
}

const mapDispatchToProps = (dispatch: Dispatcher): Partial<PaymentStore> => {
  return {
    getPrice: ({ relativeId, callTypeValue }: { relativeId?: string, callTypeValue?: DoctorType }) =>
      dispatch(actions.priceRequest({ relativeId, callTypeValue })),
    tlcRequest: (a: Answer[]) => dispatch(actions.submit(a)),
    reset: () => dispatch(actions.reset()),
  }
}
// Give the store inside the props
export default connect(
  ({
    payment,
    stripe,
  }: {
    payment: PaymentStore
    stripe: { message?: Message }
  }) => {
    return {
      ...payment,
      message: payment.message ?? stripe.message,
    }
  },
  mapDispatchToProps
)(withSurveyController(Payment, { hideNext: true, hideTitle: true }))
